export default __webpack_public_path__ + "static/media/Wine Bottle.8f09aa78.jpg";